module.exports = __webpack_public_path__ + "img/have_a_nice_day.png";